import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { getSettings } from "@/lib/api";
import { PrescriptionLayoutConfig } from "@/types/prescription";

export const DEFAULT_PRESCRIPTION_LAYOUT: PrescriptionLayoutConfig = {
  hiddenSections: [],
  customFields: [
    { key: "custom_1", label: "", enabled: false },
    { key: "custom_2", label: "", enabled: false },
    { key: "custom_3", label: "", enabled: false },
  ],
};

export function usePrescriptionLayout() {
  const { currentUser } = useAuth();
  const [layout, setLayout] = useState<PrescriptionLayoutConfig>(DEFAULT_PRESCRIPTION_LAYOUT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser?.doctor_id || !currentUser?.clinic_id) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    getSettings(currentUser.doctor_id, currentUser.clinic_id)
      .then((settings) => {
        if (!cancelled) setLayout(settings.prescriptionLayout || DEFAULT_PRESCRIPTION_LAYOUT);
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [currentUser?.doctor_id, currentUser?.clinic_id]);

  return { layout, loading };
}
